import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@img/icon-search.png'
import _imports_1 from '@img/icon-delete.png'
import _imports_2 from '@img/icon_language.svg'
import _imports_3 from '@img/icon-gold.png'
import _imports_4 from '@img/icon-gem.png'
import _imports_5 from '@img/vip-panel.png'
import _imports_6 from '@img/icon-purchasedgames.svg'
import _imports_7 from '@img/icon-signout.png'


const _withScopeId = n => (_pushScopeId("data-v-57508051"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-inner container" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "nav-tab-list" }
const _hoisted_5 = ["title", "onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "inner" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "right" }
const _hoisted_13 = { class: "flex items-center selected-option fs-14 text-center flex" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-18 h-18 block mr-9 inline-block",
  alt: ""
}, null, -1))
const _hoisted_15 = { class: "mr-10 cursor-pointer" }
const _hoisted_16 = { class: "language-box" }
const _hoisted_17 = { class: "dropdown" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "dropdown-option-icon ml-12 mr-8" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_21 = { class: "num" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_23 = { class: "num" }
const _hoisted_24 = ["data-error", "data-loading"]
const _hoisted_25 = { class: "avatar-popover-header" }
const _hoisted_26 = ["data-error", "data-loading"]
const _hoisted_27 = { class: "info" }
const _hoisted_28 = { class: "username" }
const _hoisted_29 = { class: "userId" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_31 = { class: "time" }
const _hoisted_32 = { class: "contact-us" }
const _hoisted_33 = { class: "my-assets" }
const _hoisted_34 = { class: "golds" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_36 = { class: "num" }
const _hoisted_37 = { class: "gems" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_39 = { class: "num" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popover = _resolveComponent("Popover")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", {
    class: "header-container",
    style: _normalizeStyle({
      backgroundColor: _ctx.currentNav?.bgColor,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: require('@img/icon-logo.png'),
          alt: "",
          class: "logo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/'))),
          title: "chikii"
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navTabList, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["item", {
              active: item.name === _ctx.route.name,
              vipicon: item.name === 'VIP',
            }]),
              key: item.name,
              title: item.name,
              ref_for: true,
              ref: _ctx.setElementRef(idx),
              onClick: ($event: any) => (_ctx.changeNavTab(item.name, idx))
            }, [
              (item.icon)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "w-32 h-16 inline-block",
                    src: item.icon
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(item.icon ? "" : item.label), 1)
            ], 10, _hoisted_5))
          }), 128)),
          (_ctx.currentNav)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["underline", {
              vipicon: _ctx.currentNav?.name === 'VIP',
              'transiton-line': !_ctx.isInitPage,
            }]),
                style: _normalizeStyle({ transform: `translateX(${_ctx.navTransLen}px)` })
              }, null, 6))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["search", { active: _ctx.searchIpt || _ctx.isIptFocus }]),
          style: _normalizeStyle({
            backgroundColor: _ctx.currentNav?.searchBgColor,
          }),
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleSearchIptFocus && _ctx.handleSearchIptFocus(...args)))
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: "search-icon",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: _ctx.$t('Header.SearchGame'),
            class: "search-ipt",
            ref: "searchIptDom",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchIpt) = $event)),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.searchWhenKeyupEnter && _ctx.searchWhenKeyupEnter(...args)), ["stop"]), ["enter"]))
          }, null, 40, _hoisted_7), [
            [_vModelText, _ctx.searchIpt]
          ]),
          _createElementVNode("div", {
            class: "search-delete",
            onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: "",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearIpt && _ctx.clearIpt(...args)))
            })
          ]),
          (_ctx.communityList.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "search-result-panel",
                onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.communityList, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "item",
                      key: item.communityId!,
                      onClick: ($event: any) => (_ctx.selectHotkey(item.name!))
                    }, [
                      _hoisted_10,
                      _createElementVNode("div", {
                        class: "content ellipsis",
                        innerHTML: item.matchName
                      }, null, 8, _hoisted_11)
                    ], 8, _hoisted_9))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 6), [
          [_vShow, _ctx.canShowSearchIpt]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: "select mr-8 h-40",
            onMouseenter: _cache[8] || (_cache[8] = ($event: any) => {
              _ctx.isPageFirstOpen = true;
              _ctx.languageSelectOpen = true;
            }),
            onMouseleave: _cache[9] || (_cache[9] = ($event: any) => (_ctx.languageSelectOpen = false))
          }, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.currentLanguage), 1),
              _createElementVNode("i", {
                class: _normalizeClass([{
                  'selected-option-open': _ctx.languageSelectOpen,
                  'selected-option-arrow-row': _ctx.languageSelectOpen,
                  'selected-option-close':
                    _ctx.isPageFirstOpen && !_ctx.languageSelectOpen,
                }, "inline-block selected-option-arrow w-10 h-6"])
              }, null, 2)
            ]),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.value,
                        class: "dropdown-option flex items-center cursor-pointer",
                        onClick: _withModifiers(($event: any) => (_ctx.selectLanguage(item)), ["stop"])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["dropdown-option-content", { active: item.label === _ctx.currentLanguage }])
                        }, [
                          _hoisted_19,
                          _createTextVNode(" " + _toDisplayString(item.label), 1)
                        ], 2)
                      ], 8, _hoisted_18))
                    }), 128))
                  ])
                ], 512), [
                  [_vShow, _ctx.languageSelectOpen]
                ])
              ]),
              _: 1
            })
          ], 32)
        ]),
        (_ctx.isSignIn)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives(_createElementVNode("div", {
                class: "assets-box",
                style: _normalizeStyle({
              backgroundColor: _ctx.currentNav?.assetsBoxBg,
            })
              }, [
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.golds), 1),
                _hoisted_22,
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.gems), 1),
                _createElementVNode("div", {
                  class: "recharge active-btn",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openRecharge && _ctx.openRecharge(...args)))
                }, _toDisplayString(_ctx.$t("Header.recharge")), 1)
              ], 4), [
                [_vShow, _ctx.canShowSearchIpt]
              ]),
              _createVNode(_component_Popover, {
                trigger: "hover",
                placement: "bottomRight",
                overlayClassName: "avatar-popover",
                color: "#292929"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("img", {
                      "data-error": require('@img/default-avatar.png'),
                      "data-loading": require('@img/default-avatar.png'),
                      alt: ""
                    }, null, 8, _hoisted_26), [
                      [_directive_lazy, _ctx.userInfo.icon]
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.userInfo?.nickname), 1),
                      _createElementVNode("div", _hoisted_29, "ID " + _toDisplayString(_ctx.userInfo?.id2), 1)
                    ])
                  ]),
                  (_ctx.userInfo?.vipInfo?.vipLevelType)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "vip-panel",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.turnVipPage && _ctx.turnVipPage(...args)))
                      }, [
                        _hoisted_30,
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("Header.maturity")) + ": " + _toDisplayString(_ctx.vipExpireTime), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("Header.contactUs")) + ": chikiifeedback@gmail.com ", 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.golds), 1)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.gems), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "purchased-game",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleOpenPurchasedGame && _ctx.handleOpenPurchasedGame(...args)))
                  }, [
                    _hoisted_40,
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("Header.purchasedGame")), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "sign-out active-btn",
                    title: "Sign Out",
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handlerLoginout && _ctx.handlerLoginout(...args)))
                  }, [
                    _hoisted_41,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("Header.signOut")), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("img", {
                    class: "avatar",
                    "data-error": require('@img/default-avatar.png'),
                    "data-loading": require('@img/default-avatar.png'),
                    alt: ""
                  }, null, 8, _hoisted_24), [
                    [_directive_lazy, _ctx.userInfo.icon]
                  ])
                ]),
                _: 1
              })
            ], 64))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "login-btn flex-btn active-btn",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handlerLogin && _ctx.handlerLogin(...args)))
            }, _toDisplayString(_ctx.$t("Header.login")), 1))
      ])
    ])
  ], 4))
}